<template>
  <div class="theme impact" id="contact">
    <div class="c-fluid">
      <small class="px-2 pointer" @click="scrollToTop()">
        <i class="fas fa-chevron-up pr-1"></i> scroll to top
      </small>
      <div class="row justify-content-between mx-auto">
        <div class="col-12 col-lg-5" id="contactForm">
          <div class="my-4">
            <input id="contactName" class="info" />
            <p class="text-right info-label mt-2">F U L L &nbsp; N A M E</p>
          </div>
          <div class="row my-4">
            <div class="col-6">
              <input id="contactEmail" class="info" />
              <p class="text-right info-label mt-2">E M A I L</p>
            </div>
            <div class="col-6">
              <input id="contactCountry" class="info" />
              <p class="text-right info-label mt-2">C O U N T R Y</p>
            </div>
          </div>
          <div class="my-4">
            <textarea class="info" rows="6" id="contactMessage"></textarea>
            <p class="text-right info-label mt-2">H O W &nbsp; C A N &nbsp; W E &nbsp; H E L P ?</p>
          </div>
          <small class="d-none c-delivered mb-3">Message sent!</small>
          <button
            class="btn-main text-white p-3"
            @click="sendMessage()"
          >S E N D &nbsp; M E S S A G E</button>
        </div>
        <div class="col-12 col-lg-6 text-right">
          <div class="my-4">
            <p>
              <a href="tel: +2348145069315">+2348145069315</a>
            </p>
            <p>
              <a href="mailto: info@awesomeandbeautiful.org">info@awesomeandbeautiful.org</a>
            </p>
            <p class="mb-0">61, Effurun Sapele Road,</p>
            <p class="mb-0">Uvwie, Warri - Delta State.</p>
            <p class="mb-0">P.O. Box 2124</p>
          </div>
          <div class="my-4">
            <a href="https://m.facebook.com/youareawesomenbeautiful/?ref=bookmarks" target="_blank">
              <svgicon icon="facebook" color="#ffc001" class="icon mr-3 pointer"></svgicon>
            </a>
            <a href="https://www.instagram.com/youareawesomenbeautiful/" target="_blank">
              <svgicon icon="instagram" color="#ffc001" class="icon mx-3 pointer"></svgicon>
            </a>
            <a href="https://twitter.com/youareawesomenbeautiful" target="_blank">
              <svgicon icon="twitter" color="#ffc001" class="icon ml-3 pointer"></svgicon>
            </a>
          </div>
          <!-- <div class="my-4">
            <p class="mb-0">Donate to: GTBank</p>
            <p class="mb-0">0123456789</p>
            <p class="mb-0">A &amp; B Foundation</p>
          </div>-->
        </div>
      </div>

      <div class="text-right">
        <small class="mr-3 policy">
          <a
            href="/static/docs/TandC.pdf"
            target="_blank"
          >T E R M S &nbsp; &amp; &nbsp; C O N D I T I O N S</a>
        </small>
        <small class="ml-3 policy">
          <a href="/static/docs/privacy.pdf" target="_blank">P R I V A C Y &nbsp; P O L I C Y</a>
        </small>
      </div>

      <div class="d-block d-sm-none mt-4">
        <p>
          <small>&copy; 2019 Awesome and Beautiful Initiative. All rights reserved.</small>
        </p>
        <p>
          <small>Made with ❤️ by Wura</small>
        </p>
      </div>

      <div class="d-none d-sm-block mt-4">
        <small>Made with ❤️ by Wura</small>
        <small
          class="float-right"
        >&copy; 2019 Awesome and Beautiful Initiative. All rights reserved.</small>
      </div>
    </div>
  </div>
</template>

<script>
import "./../compiled-icons/facebook";
import "./../compiled-icons/twitter";
import "./../compiled-icons/instagram";

export default {
  name: "Impact",
  data() {
    return {};
  },
  methods: {
    sendMessage() {
      startSpinner("#contactForm");
      $.ajax({
        type: "POST",
        url: "/contactUs",
        contentType: "application/json",
        data: JSON.stringify({
          subject: "FROM CONTACT US",
          name: $("#contactName")
            .val()
            .trim(),
          email: $("#contactEmail")
            .val()
            .trim(),
          message: $("#contactMessage")
            .val()
            .trim(),
          country: $("#contactCountry")
            .val()
            .trim()
        })
      }).always(function(response) {
        if (response.status) {
          $("#contactName").val("");
          $("#contactEmail").val("");
          $("#contactMessage").val("");
          $("#contactCountry").val("");
        }
        $(".c-delivered").html(
          '<span class="text-danger">*</span> ' + response.message
        );
        $(".c-delivered").removeClass("d-none");
        console.log(response);
        stopSpinner();
      });
    },
    scrollToTop() {
      $(document).scrollTop(0);
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .c-fluid {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
}

@media screen and (min-width: 801px) {
  .c-fluid {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
}
.theme {
  color: white;
  padding: 6rem 0 1rem 0;
}
.impact {
  background-image: url("/static/imgs/contact.png");
  background-size: cover;
}

input,
textarea {
  color: white;
}
.info {
  border-bottom: 1px solid white;
}

@media screen and (max-width: 800px) {
  .icon {
    width: 40px;
  }
}

@media screen and (min-width: 801px) {
  .icon {
    width: 30px;
  }
}
a,
a:hover {
  color: unset !important;
}
.c-delivered {
  display: block;
}

@media screen and (max-width: 600px) {
  .policy {
    display: block;
    margin: 10px 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue